import React, { Component } from 'react';
import {
   Col, Card, CardBody, Table, Button, Row, FormGroup,
} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import Moment from 'moment';
import CalendarIcon from 'mdi-react/CalendarIcon';
import DatePicker from 'react-datepicker';
import AsyncSelect from 'react-select/lib/Async';
import ReactPaginate from 'react-paginate';

import SelectService from '../../../services/SelectService';
import CommonService from '../../../services/CommonService';
import global from '../../../global';

class ProfitReport extends Component {
   constructor() {
      super();
      this.state = {
         realList: [],
         list: [],
         formdata: {
            locationId: '',
         },
         totalProfit: 0,
         goTo: false,
         lastPageVisited: window.history.state !== null ? window.history.state.state.prevpage : '',
      };
      this.userdata = JSON.parse(localStorage.getItem('userData'));
      this.searchTransaction = this.searchTransaction.bind(this);
      this.handleClick = this.handleClick.bind(this);
   }

   componentDidMount() {
      this.isLoading = true;
      this.loadProfitTable();
   }

   loadProfitTable = async (fromDate = '', toDate = '', locationID = '', productID = '') => {
      try {
         const dateFrom = fromDate !== '' ? fromDate : Moment(new Date()).format('YYYY-MM-DD');
         const dateTo = toDate !== '' ? toDate : Moment(new Date()).format('YYYY-MM-DD');
         const locID = locationID !== '' ? `/locationid/${locationID}` : '';
         const prodID = productID !== '' ? `/productid/${productID}` : '';

         const response = await CommonService.getRows(`profitreportlist/datefrom/${dateFrom}/dateto/${dateTo}${locID}${prodID}`);
         if (response) {
            const rlist = Object.values(response.list);
            this.setState({ list: response.list, realList: rlist, totalProfit: response.total_profit });
            this.handleClick();
         }
      } catch (err) {
         console.log('Error: ', err.message);
         this.isLoading = false;
      }
   }

   goBack = () => {
      this.setState({ goTo: true });
   }

   getLocations = async (newValue) => {
      this.isLoading = true;
      const formData = { searchFor: newValue, searchType: 9 };
      const options = [];
      if (this.isLoading) {
        await SelectService.listLocationOptions(formData).then((response) => {
          if (response) {
            response.map(opt => (
              options.push({
                value: opt.location_id,
                label: opt.location_name,
              })
            ));
          }
        }).catch((error) => {
          console.log('Error: ', error.message);
        });
        this.isLoading = false;
      }

      return options;
    }

   getProducts = async (newValue) => {
      this.isLoading = true;
      const formData = { searchFor: newValue };
      const options = [];
      if (this.isLoading) {
        await SelectService.listProductOptions(formData).then((response) => {
          if (response) {
            response.map(opt => (
              options.push({
                value: opt.product_id,
                label: opt.product_name,
              })
            ));
          }
        }).catch((error) => {
          console.log('Error: ', error.message);
        });
        this.isLoading = false;
      }

      return options;
    }

   handleChange = (e, fieldName) => {
      if (fieldName === 'fromDate') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           fromDate: date,
         },
       }));
     } else if (fieldName === 'toDate') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           toDate: date,
         },
       }));
     } else if (fieldName === 'productid') {
         let productId = '';
         if (e) {
            productId = e.value;
         }

         this.setState(prevState => ({
           formdata: { ...prevState.formdata, productId },
         }));
     } else if (fieldName === 'locationid') {
         let locationId = '';
         if (e) {
            locationId = e.value;
         }

         this.setState(prevState => ({
           formdata: { ...prevState.formdata, locationId },
         }));
     } else {
       const { name, value } = e.target;
       this.setState(prevState => ({
         formdata: { ...prevState.formdata, [name]: value },
       }));
     }
   }

   handleClick(event = '') {
     const selected = event !== '' ? event.selected + 1 : 1;
     const { realList } = this.state;

     const lastPost = selected * 10;
     const firstPost = lastPost - 10;

     const newList = realList.slice(firstPost, lastPost);
     this.setState({ list: newList });
  }

   searchTransaction(e) {
      e.preventDefault();
      const { formdata } = this.state;
      const fromDate = Moment(formdata.fromDate).format('YYYY-MM-DD');
      const toDate = Moment(formdata.toDate).format('YYYY-MM-DD');
      this.loadProfitTable(fromDate, toDate, formdata.locationId, formdata.productId);
   }

   render() {
      const {
         list, goTo, lastPageVisited, formdata, totalProfit, realList,
      } = this.state;

      if (goTo === true) {
         return <Redirect to={{ pathname: lastPageVisited }} />;
      }

      if (this.userdata.type !== '1') {
         return <Redirect to="/dashboard" />;
      }

      // from date
      let fromDate = new Date();
      if (formdata.fromDate) {
        fromDate = new Date(formdata.fromDate);
      }
      // to date
      let toDate = new Date();
      if (formdata.toDate) {
        toDate = new Date(formdata.toDate);
      }

      const listLength = Object.values(list);

      return (
         <Col md={12}>
            <Card className="panel panel--primary" id="users_table">
               <CardBody className="panel__body">
                  <div className="panel__title bg_blue">
                     <h5 className="bold-text">Profit Table</h5>
                     <div className="panel__btns">
                     {
                        lastPageVisited !== '' ? (
                           <Button onClick={this.goBack} className="rounded text-white btn btn-sm btn-outline-secondary btn-awesome" size="sm" outline>
                           <i className="fa fa-arrow-left" />
                           <span>Back</span>
                           </Button>
                        ) : ''
                     }
                     </div>
                  </div>
                  <Row className="m-0">
                     <Col md={12} className="m-b-20">
                        <form className="form form--horizontal the_form_display" onSubmit={this.searchTransaction}>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Product:</span>
                                 <div className="form__form-group-icon mh-38">
                                    <CalendarIcon />
                                 </div>
                                 <AsyncSelect
                                    name="productid"
                                    cacheOptions
                                    loadOptions={this.getProducts}
                                    defaultOptions
                                    isClearable
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    placeholder="Product name..."
                                    onChange={e => this.handleChange(e, 'productid')}
                                 />
                              </div>
                           </div>

                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Location:</span>
                                 <div className="form__form-group-icon mh-38">
                                    <CalendarIcon />
                                 </div>
                                 <AsyncSelect
                                    name="locationid"
                                    cacheOptions
                                    loadOptions={this.getLocations}
                                    defaultOptions
                                    isClearable
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    placeholder="Location name..."
                                    onChange={e => this.handleChange(e, 'locationid')}
                                 />
                              </div>
                           </div>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Date From:</span>
                                 <div className="form__form-group-icon">
                                    <CalendarIcon />
                                 </div>
                                 <DatePicker
                                    name="fromDate"
                                    selected={fromDate}
                                    popperPlacement="top"
                                    onChange={e => this.handleChange(e, 'fromDate')}
                                 />
                              </div>
                           </div>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Date To:</span>
                                 <div className="form__form-group-icon">
                                    <CalendarIcon />
                                 </div>
                                 <DatePicker
                                    name="toDate"
                                    selected={toDate}
                                    popperPlacement="top-end"
                                    onChange={e => this.handleChange(e, 'toDate')}
                                 />
                                 <button type="submit" className="form__form-group-button bg-primary">Search</button>
                              </div>
                           </div>
                        </form>
                     </Col>
                  </Row>
                  <div className="panel__content">
                  <h3>Total Profit: {totalProfit <= 0 ? <span className="text-red">&#x20B1; {global.numberFormat(totalProfit)}</span> : <span className="text-green">&#x20B1; {global.numberFormat(totalProfit)}</span>}</h3>
                  <Table responsive striped hover>
                     <thead className="th-vtop">
                        <tr>
                           <th>Product</th>
                           <th>Total Stock</th>
                           <th>Sold Stock</th>
                           <th>Remaining Stock</th>
                           <th>Total Cost</th>
                           <th>Total Sold</th>
                           <th>Profit</th>
                           <th>Margin</th>
                           <th>Markup</th>
                        </tr>
                     </thead>
                     <tbody>
                        {
                           listLength.length > 0 ? listLength.map(item => (
                                 <tr key={item.product_id} className="text-center">
                                    <td className="text-left">{item.product_name}</td>
                                    <td className="text-left">{item.total_stocks} kgs.</td>
                                    <td className="text-left">{item.sold_stocks} kgs.</td>
                                    <td className="text-left">{item.remaining_stocks} kgs.</td>
                                    <td className="text-left">&#x20B1; {global.numberFormat(item.total_cost)}</td>
                                    <td className="text-left"> {item.total_sold <= 0 ? <span className="text-red">&#x20B1; {global.numberFormat(item.total_sold)}</span> : <span>&#x20B1; {global.numberFormat(item.total_sold)}</span> }</td>
                                    <td className="text-left"> {item.profit <= 0 ? <span className="text-red">&#x20B1; {global.numberFormat(item.profit)}</span> : <span>&#x20B1; {global.numberFormat(item.profit)}</span> }</td>

                                    <td className="text-left"> {item.margin <= 0 ? <span className="text-red">{global.numberFormat(item.margin)} %</span> : <span>{global.numberFormat(item.margin)} %</span> }</td>
                                    <td className="text-left"> {item.markup <= 0 ? <span className="text-red">{global.numberFormat(item.markup)} %</span> : <span>{global.numberFormat(item.markup)} %</span> }</td>
                                 </tr>
                              )) : (
                              <tr className="text-center">
                                 <td colSpan="9">No data available..</td>
                              </tr>
                           )
                        }
                     </tbody>
                  </Table>
                  <FormGroup className={list === false || (realList.length / 10) <= 1 ? 'display-none' : ''}>
                  <ReactPaginate
                        previousLabel="<<"
                        nextLabel=">>"
                        breakLabel="..."
                        breakClassName="break-me"
                        pageCount={realList.length / 10}
                        onPageChange={this.handleClick}
                        marginPagesDisplayed={0}
                        pageRangeDisplayed={2}
                        containerClassName="list-pagination"
                        activeClassName="active"
                  />
                  </FormGroup>
                  </div>
               </CardBody>
            </Card>
         </Col>
      );
   }
}

export default withTranslation('common')(ProfitReport);
